import { apiFetch } from "./client";

export interface NotificationPrefs {
  chatToastsEnabled: boolean;
}

export const userNotificationPrefsApi = {
  get: () => apiFetch<NotificationPrefs>("/me/notification-prefs"),

  set: (chatToastsEnabled: boolean) =>
    apiFetch<{ ok: boolean; chatToastsEnabled: boolean }>(
      "/me/notification-prefs",
      {
        method: "PUT",
        body: JSON.stringify({ chatToastsEnabled }),
      },
    ),
};
